<template>
  <div class="wrapper" style="font-family: 'Fredoka', sans-serif !important">
    <!-- <div class="absolute z-10 top-8 left-1/2 -translate-x-1/2 text-center">
      <h1 class="text-4xl font-bold text-white mb-4">Bluesky Visualizer</h1>
    </div> -->
    <P5Canvas
      ref="p5Canvas"
      :speed="speed"
      :skipLogic="skipLogic"
      :paused="paused"
      :ignoreHover="ignoreHoverInCanvas"
      :filterInput="filterInput"
      :selectedFont="selectedFont"
      :fontSize="fontSize"
      :emojiOnly="emojiOnly"
    />

    <div class="fixed bottom-0 right-0">
      <div class="floating-icons flex items-center space-x-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="151"
          height="150"
          viewBox="0 0 151 150"
          class="w-14 h-14 px-4 py-4 fill-white text-white cursor-pointer"
          tabindex="0"
          role="button"
          aria-label="Open Coffee Page"
          @click="openCoffeePage"
          @keydown.enter="openCoffeePage"
        >
          <path
            d="M108.27 135.14C108.384 135.009 108.265 135.083 108.246 135.176C106.237 144.847 99.8055 148.928 90.4218 149.246C86.9295 149.364 83.4318 149.54 79.9401 149.475C67.1586 149.237 54.379 148.84 41.5969 148.647C36.2674 148.566 30.93 149.001 25.6025 148.893C22.9829 148.801 20.387 148.361 17.8827 147.587C11.5326 145.706 6.80174 141.856 4.97974 135.277C3.9086 131.409 2.85586 127.423 2.65568 123.447C1.68386 104.14 0.896231 84.8239 0.292838 65.4987C0.259224 61.2417 0.635739 56.9913 1.41715 52.8065C2.03017 49.0555 3.12363 48.7069 6.78403 48.7024C16.4978 48.6897 26.2116 48.5584 35.9254 48.3086C57.8786 47.752 79.8285 47.0615 101.782 46.5174C106.188 46.4085 106.388 46.8456 107.287 51.0797C107.889 53.9111 108.752 56.6867 109.569 59.7492C109.846 59.7335 110.366 59.7347 110.877 59.6685C130.965 57.0707 144.376 66.3014 148.945 85.9108C150.494 92.5569 151.203 99.3001 150.151 106.07C147.805 121.159 137.914 131.1 122.366 133.859C117.895 134.651 113.293 134.706 108.27 135.14ZM7.79021 56.3474C7.79021 58.2659 7.70816 60.1095 7.80399 61.944C8.36778 72.7394 8.80623 83.5454 9.61024 94.3244C10.4307 105.317 11.3981 116.312 12.7337 127.248C13.6145 134.463 17.8683 138.508 25.0073 139.792C28.4378 140.461 31.9162 140.856 35.4096 140.973C51.5756 141.26 67.7434 141.437 83.9129 141.507C86.9645 141.417 90.008 141.145 93.0268 140.689C96.2554 140.315 97.9776 138.375 98.7061 135.242C100.261 128.56 100.075 121.822 99.7943 115.042C99.1406 99.2258 98.5696 83.4067 98.0813 67.5846C97.931 62.9364 98.0577 58.279 98.0577 53.2049L7.79021 56.3474ZM109.594 127.126C115.415 126.032 121.014 125.534 126.246 123.879C136.041 120.781 141.507 113.69 142.492 103.432C143.157 96.5166 142.045 89.7642 140.223 83.0603C136.144 68.042 119.247 63.2672 108.706 65.9647V73.9248C126.409 77.4159 131.52 86.5455 132.052 98.5762C132.249 102.987 130.674 106.912 128.045 110.428C123.499 116.511 116.872 118.375 109.594 119.192V127.126ZM108.823 110.478C112.06 109.276 114.784 108.509 117.286 107.28C121.349 105.289 123.418 101.836 123.56 97.2943C123.836 88.481 118.428 82.5504 108.823 80.9457V110.478Z"
          />
          <path
            d="M51.7362 2.12827C51.4921 3.51446 51.3995 4.38875 51.1809 5.23017C49.6812 10.9987 50.9722 16.2376 54.1292 21.1411C55.7228 23.6161 57.5921 25.9704 58.7932 28.6233C60.0683 31.4908 60.9871 34.5037 61.5288 37.5948C61.7027 39.3173 61.3493 41.052 60.5154 42.5692C60.0362 43.5163 58.4591 44.5106 57.4667 44.424C56.4743 44.3374 55.4642 43.0326 54.7508 42.0514C54.2939 41.297 54.0914 40.4158 54.1732 39.5376C54.5263 34.0644 52.0302 29.619 49.1614 25.3055C45.7845 20.2274 43.9192 14.7063 44.821 8.59647C45.2757 6.03906 46.0934 3.55972 47.2495 1.23366C47.5901 0.501187 49.2618 -0.0606076 50.203 0.0837867C50.8869 0.189457 51.368 1.5927 51.7362 2.12827Z"
          />
          <path
            d="M67.708 11.3474C68.516 8.197 69.1316 5.21921 70.0708 2.3497C70.6136 0.689164 71.9742 -0.488994 73.8993 0.200817C75.7042 0.845997 75.8295 2.48887 75.3563 4.04767C73.5186 10.1076 75.0347 15.6051 77.6981 21.0862C79.5766 25.0113 81.1887 29.0585 82.5235 33.2002C83.072 35.0863 83.1482 37.0784 82.7454 39.0009C82.5248 40.1344 81.2122 41.6833 80.1929 41.8513C79.2386 42.0082 77.8918 40.7264 76.9768 39.8167C76.4222 39.2667 76.356 38.2238 76.0731 37.4014C74.0903 31.6421 72.0504 25.9011 70.1496 20.1148C69.2045 17.2545 68.5199 14.3009 67.708 11.3474Z"
          />
          <path
            d="M31.209 41.5391C31.2061 41.4289 31.2162 41.3187 31.2392 41.2109C33.2916 35.1549 30.4687 30.6104 27.0262 25.9314C24.6289 22.7749 23.3055 18.9336 23.25 14.9704C23.1945 11.0072 24.4097 7.13036 26.7177 3.908C27.8039 2.5859 29.17 1.52131 30.7174 0.791033C31.3515 0.462864 33.0146 0.851377 33.2942 1.39089C33.6834 2.13714 33.4439 3.4361 33.056 4.31428C32.3596 5.88949 31.1309 7.24477 30.5153 8.84295C28.3421 14.4829 29.0648 19.7415 32.928 24.5124C35.4221 27.5886 37.5689 30.8513 38.1229 34.9192C38.6591 38.8573 37.4285 42.0733 34.7572 43.4818C32.691 44.5766 31.2655 43.7949 31.209 41.5391Z"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="86"
          height="124"
          viewBox="0 0 86 124"
          class="w-14 h-14 px-4 py-4 fill-white text-white cursor-pointer"
          tabindex="0"
          role="button"
          aria-label="Toggle Info"
          @click="toggleInfoVisible"
          @keydown.enter="toggleInfoVisible"
        >
          <g>
            <path
              d="M66.9413 6.80024C59.1446 2.43766 50.3245 0.277133 41.4114 0.546415C33.6617 0.308912 25.9438 1.64708 18.7181 4.48125C12.0212 7.16705 7.11762 10.8027 3.73179 15.5952C2.58277 17.3085 1.79652 19.2423 1.42204 21.2758C0.97128 23.5617 1.7923 25.2296 3.67583 25.8522C5.85814 26.5728 7.23824 25.1582 8.4057 23.5228L8.82169 22.9385C10.1179 21.1077 11.4584 19.2152 13.1488 17.9545C15.7556 16.0268 18.6039 14.4551 21.6193 13.2801C28.0755 10.7638 35.2167 9.95614 44.0928 10.7417C50.2398 11.2857 55.4312 12.7133 59.9633 15.1056C66.4404 18.5244 70.5686 22.8625 72.5848 28.3679C75.4394 36.1682 73.865 42.4267 67.9047 46.9699C64.5038 49.4399 60.9478 51.6851 57.2593 53.6917L57.0866 53.7904C55.3042 54.811 53.4087 55.7231 51.5754 56.6054C50.2875 57.2254 48.9544 57.8675 47.6633 58.5446C38.7931 63.1962 32.6943 69.339 29.0187 77.3231C28.0815 79.2688 27.4163 81.3352 27.0419 83.4647C26.7751 85.0929 26.8451 86.7588 27.2472 88.3584C27.6494 89.9574 28.3749 91.4558 29.3787 92.7595C30.3774 94.0916 31.4057 94.378 32.0928 94.3825H32.1129C32.5959 94.363 33.0677 94.2306 33.4907 93.9943C33.9137 93.7586 34.276 93.4262 34.5487 93.0237C35.0787 92.3394 35.6177 91.6603 36.1586 90.9819C37.5836 89.1849 39.0565 87.3268 40.3515 85.3785C44.398 79.2837 49.9011 74.3075 57.6696 69.7175C62.4729 66.9668 67.1332 63.9695 71.6324 60.7377C74.789 58.4139 77.6243 55.6764 80.0629 52.5972C85.1732 46.0616 86.8635 38.6007 85.0863 30.4212C82.8833 20.3058 76.7788 12.3601 66.9413 6.80024Z"
            />
            <path
              d="M30.0332 123.356C30.5839 123.438 31.1398 123.48 31.6965 123.479C34.3927 123.446 37.0093 122.554 39.1723 120.931C41.3352 119.308 42.9333 117.037 43.738 114.442C44.2238 112.472 44.2537 110.416 43.8254 108.432C43.3971 106.449 42.5221 104.591 41.2679 103.003C40.3147 101.695 39.0606 100.641 37.6134 99.9325C36.1662 99.2229 34.5695 98.8795 32.9612 98.9308C30.8239 98.9379 30.4738 99.0873 26.9591 101.159C24.5168 102.527 22.6082 104.692 21.5469 107.297C20.4857 109.903 20.3345 112.795 21.1184 115.499C22.4288 120.022 25.4291 122.665 30.0332 123.356ZM31.4931 106.086C31.6863 106.346 31.8793 106.59 32.066 106.831C32.6296 107.467 33.0916 108.188 33.4356 108.968C33.8303 110.059 33.9134 111.24 33.6752 112.377C33.4679 112.932 33.0586 113.386 32.5304 113.648C31.8288 114.105 30.9879 114.294 30.16 114.182C29.7343 114.067 28.4395 113.715 28.5278 111.157C28.6224 108.422 29.4898 106.917 31.4938 106.082L31.4931 106.086Z"
            />
          </g>
          <defs>
            <clipPath>
              <rect width="85" height="124" transform="translate(0.777344)" />
            </clipPath>
          </defs>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="157"
          height="133"
          viewBox="0 0 157 133"
          class="w-14 h-14 px-4 py-4 fill-white text-white cursor-pointer"
          role="button"
          tabindex="0"
          aria-label="Toggle Dialog"
          @click="toggleDialogVisible"
          @keydown.enter="toggleDialogVisible"
          ref="dialogIcon"
        >
          <g>
            <path
              d="M126.506 116.642C126.083 118.028 125.781 119.205 125.368 120.34C122.745 127.559 117.164 131.078 109.994 132.496C104.277 133.639 98.3414 132.499 93.451 129.318C88.6571 126.351 86.3462 121.873 85.8775 116.058C84.9312 115.977 83.981 115.831 83.0294 115.823C62.3275 115.661 41.6249 115.549 20.9235 115.34C16.3969 115.294 11.8677 114.988 7.35279 114.638C6.13966 114.566 4.98132 114.107 4.04702 113.328C3.27571 112.449 2.82996 111.331 2.78476 110.161C2.70385 108.799 3.79068 108.021 5.09888 107.733C5.7433 107.588 6.40009 107.506 7.06018 107.487C15.2428 107.327 23.4247 107.138 31.6079 107.047C47.2169 106.874 62.8257 106.734 78.4342 106.626C81.7471 106.599 85.0607 106.622 87.9755 106.622C90.2896 103.916 92.1739 101.285 94.4802 99.1013C100.131 93.7508 106.949 92.6089 114.236 94.6805C119.331 96.1292 123.009 99.3089 124.075 104.856C124.178 105.394 124.407 105.91 124.731 106.913C125.773 106.913 126.949 106.899 128.125 106.913C135.099 107.005 142.074 107.061 149.046 107.234C150.589 107.28 152.116 107.558 153.577 108.058C154.484 108.353 155.265 108.947 155.793 109.743C156.322 110.538 156.568 111.489 156.49 112.442C156.51 113.342 156.235 114.224 155.709 114.954C155.182 115.684 154.432 116.221 153.572 116.484C152.1 116.936 150.565 117.152 149.025 117.124C142.715 117.032 136.408 116.808 130.099 116.644C129 116.618 127.899 116.642 126.506 116.642ZM116.486 112.101C116.47 108.857 115.709 105.628 114.215 103.641C113.638 102.879 112.823 102.334 111.899 102.092C105.369 100.776 98.3886 105.745 96.7147 111.546C95.2615 116.584 96.8552 119.771 101.764 121.567C109.834 124.52 116.528 120.219 116.486 112.102V112.101Z"
            />
            <path
              d="M59.3029 59.9005C62.4922 59.9005 65.3571 59.9705 68.2185 59.8887C81.7252 59.5025 95.2337 59.0902 108.743 58.652C121.144 58.2342 133.541 57.7263 145.941 57.2819C147.487 57.1702 149.039 57.2012 150.58 57.3741C151.695 57.494 152.732 58.0071 153.505 58.8221C154.278 59.6371 154.737 60.7007 154.8 61.8233C154.822 63.8495 153.384 65.5822 150.955 66.2349C149.882 66.4996 148.783 66.6365 147.679 66.6411C127.633 67.0887 107.588 67.524 87.5444 67.947C78.5734 68.1495 69.6044 68.4291 60.6344 68.6834C60.0933 68.699 59.5541 68.8041 58.7352 68.8995C56.6185 79.1813 49.3189 83.497 39.7511 83.5619C31.2067 83.6229 24.7292 79.3954 21.9931 70.6778C17.6788 70.4831 13.4861 70.3482 9.30198 70.0776C7.76153 69.9622 6.23731 69.6858 4.75405 69.253C4.09666 69.0921 3.51863 68.6996 3.12465 68.1482C2.73068 67.5967 2.54681 66.922 2.60631 66.2459C2.60289 65.5673 2.84974 64.9107 3.29952 64.4029C3.74929 63.8951 4.37031 63.5718 5.04341 63.4947C6.23958 63.2824 7.4538 63.1894 8.66827 63.2176C12.9761 63.1871 17.2845 63.2052 21.635 63.2052C22.0882 61.8791 22.4526 60.9723 22.7096 60.0361C23.6986 56.3646 25.732 53.0606 28.5618 50.5273C30.3901 48.9344 32.6003 47.8453 34.9753 47.3671C38.4617 46.7658 42.0035 46.5511 45.5367 46.7269C52.2078 46.9617 56.2819 50.8234 58.4776 56.9128C58.8116 57.8464 59.0103 58.8287 59.3029 59.9005ZM39.0229 56.0302C37.7134 56.3248 35.4045 56.304 33.7312 57.3278C29.7056 59.7932 29.8111 69.0565 33.7772 71.6873C37.3917 74.0878 41.2898 73.9801 45.1328 72.1732C48.59 70.548 48.9655 67.1127 49.0264 64.0181C49.1125 59.6408 48.025 56.8018 42.4336 56.3509C41.5578 56.2795 40.6774 56.1853 39.0229 56.0302Z"
            />
            <path
              d="M97.708 23.2841C96.6976 23.2841 95.9312 23.2783 95.1654 23.2841C68.2583 23.5004 41.3518 23.7143 14.4469 23.9262C12.1222 23.9444 9.79756 23.9065 7.47284 23.8122C6.25571 23.7704 5.04522 23.6131 3.85766 23.3424C1.93388 22.8883 0.738977 21.5117 0.793997 19.9176C0.785629 19.1288 1.05508 18.3623 1.55497 17.753C2.05485 17.1438 2.75313 16.7307 3.5269 16.5866C4.80784 16.2558 6.11675 16.0456 7.43665 15.9581C35.9633 14.1221 64.5352 14.0634 93.1012 13.7909C94.7524 13.7754 96.4024 13.7909 98.1229 13.7909C98.7353 12.5031 99.2758 11.4328 99.7593 10.337C100.909 7.52909 103.037 5.23489 105.747 3.8809C109.732 1.95467 113.888 0.385482 118.369 0.0740674C126.081 -0.462474 130.772 2.65224 133.35 9.93088C133.674 10.8534 133.969 11.7883 134.369 13.0003C138.362 12.8115 142.318 12.587 146.276 12.4566C147.706 12.3641 149.142 12.4489 150.551 12.7095C151.49 12.8883 152.343 13.3743 152.976 14.0912C153.61 14.8083 153.988 15.7157 154.051 16.6712C154.115 17.6267 153.86 18.5765 153.326 19.3712C152.794 20.1659 152.012 20.7607 151.105 21.0625C149.75 21.5344 148.339 21.8265 146.908 21.9308C142.619 22.3129 138.32 22.5827 133.832 22.911C131.178 32.5129 124.224 36.4282 114.891 36.1733C106.551 35.9449 100.21 32.26 97.708 23.2841ZM105.849 18.282C105.147 22.7405 109.493 27.5251 114.151 27.3707C121.1 27.1404 125.243 23.2268 125.24 18.0216C125.24 12.1696 122.484 9.01357 116.03 8.71318C109.904 8.42837 105.899 12.3911 105.849 18.282Z"
            />
          </g>
          <defs>
            <clipPath>
              <rect width="156" height="133" transform="translate(0.777344)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <!-- For some reason "hidden lg:fixed" wasn't working, so hacking by using positioning -->
    <div
      class="glass-pill creator-pill fixed -bottom-12 lg:bottom-3 left-4 text-gray-800 px-4 flex items-center text-sm h-8"
    >
      Created by
      <a
        href="https://bsky.app/profile/shrikhalpada.dev"
        target="_blank"
        class="font-semibold ml-1"
      >
        @shrikhalpada.dev
      </a>
    </div>

    <div
      class="fixed bottom-3 left-4 flex items-center justify-center gap-4 lg:left-1/2 lg:transform lg:-translate-x-1/2"
    >
      <el-button
        @click="togglePause"
        class="dream-button px-4 py-4 fill-white cursor-pointer"
      >
        <span>
          {{ paused ? "Play" : "Pause" }}
          <span class="hidden sm:inline">
            <span class="ml-1 text-gray-400"> (</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="800px"
              height="800px"
              viewBox="0 0 24 24"
              class="w-4 h-4 mt-0.5 fill-gray-400 cursor-pointer inline"
            >
              <path
                d="M21,9c-0.6,0-1,0.4-1,1v3H4v-3c0-0.6-0.4-1-1-1s-1,0.4-1,1v4c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1v-4C22,9.4,21.6,9,21,9z"
              />
            </svg>
            <span class="text-gray-400">)</span>
          </span>
        </span>
      </el-button>

      <div class="hidden sm:block">
        <el-input
          :class="emojiOnly ? 'opacity-50' : 'opacity-95'"
          v-model="filterInput"
          placeholder="Filter Words..."
          :disabled="emojiOnly"
        >
        </el-input>
      </div>

      <div
        class="glass-pill text-white px-4 cursor-pointer h-8 flex items-center"
      >
        <!-- Emoji only checkbox -->
        <el-checkbox v-model="emojiOnly" class="opacity-85" @change="blurAll">
          <span class="hidden md:block">Emoji Mode 🙃</span>
          <span class="md:hidden">🙃</span>
        </el-checkbox>
      </div>
    </div>

    <!-- Settings Dialog -->
    <el-dialog v-model="isSettingsVisible" width="400px" class="rounded-lg">
      <div class="flex justify-center">
        <span class="text-3xl">Settings</span>
      </div>
      <div class="flex justify-center pb-6 pt-2 text-sm text-gray-500">
        Note: this website is an experiment and may have bugs!
      </div>
      <div class="flex flex-col gap-6 pb-2">
        <!-- Speed Control -->
        <div class="flex gap-6 justify-center items-center">
          <span class="">Speed:</span>
          <el-radio-group v-model="speed">
            <el-radio-button label="slow">Slow</el-radio-button>
            <el-radio-button label="fast">Fast</el-radio-button>
          </el-radio-group>
        </div>

        <div class="flex gap-6 justify-center items-center">
          <span class="">Font Size:</span>
          <el-radio-group v-model="fontSize">
            <el-radio-button label="small">Small</el-radio-button>
            <el-radio-button label="medium">Medium</el-radio-button>
            <el-radio-button label="large">Large</el-radio-button>
          </el-radio-group>
        </div>

        <!-- Skip Logic Control -->
        <!-- <div class="flex gap-6 justify-center items-center">
          <span class="">Skip Logic:</span>
          <el-radio-group v-model="skipLogic">
            <el-radio-button label="skip">Skip</el-radio-button>
            <el-radio-button label="queue">Queue</el-radio-button>
          </el-radio-group>

          <el-popover placement="left" width="300" trigger="hover">
            <p>
              Sometimes posts come in faster than this page can visualize.
              "Skip" makes it so that we try to always show the latest posts,
              even if we drop some. "Queue" tries to make it so that we never
              miss a post, even if we lag behind.
            </p>
            <template #reference>
              <span
                class="cursor-pointer font-semibold bg-blue-300 text-white rounded-full w-4 h-4 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-blue-300"
                tabindex="0"
                role="button"
                aria-label="More info"
              >
                ?
              </span>
            </template>
          </el-popover>
        </div> -->

        <div class="flex gap-6 justify-center items-center">
          <span>Font:</span>
          <!-- Font Chooser -->
          <div class="flex flex-col items-center">
            <el-select v-model="selectedFont" class="!w-48">
              <el-option
                v-for="font in fonts"
                :key="font.value"
                :label="font.label"
                :value="font.value"
                :style="{ fontFamily: font.value }"
              >
                {{ font.label }}
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flex gap-6 justify-center items-center -mt-2">
          <el-checkbox v-model="filterProfanity"
            >Try To Filter Profanity</el-checkbox
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog v-model="isInfoVisible" width="380px" class="rounded-lg">
      <div class="flex justify-center">
        <span class="text-2xl pb-4">About Falling Posts</span>
      </div>
      <div class="pb-2 space-y-4 px-2">
        <p>
          Hi! This is an experiment in displaying Bluesky's real-time data in a
          fun and novel way. Each word you see is part of a recent post, and you
          can hover to see the full posts. There are too many posts to show them
          all, but the ones shown are in real-time!
        </p>
        <p>
          This project was built by
          <a
            href="https://bsky.app/profile/shrikhalpada.dev"
            target="_blank"
            class="font-semibold"
            >Shri Khalpada</a
          >
          using Bluesky's WebSocket Firehose.
        </p>
        <p>
          If you enjoyed this, I've also built creative projects around
          <a href="https://drawaurora.com" target="_blank" class="font-semibold"
            >zen</a
          >,
          <a href="https://drawbeats.com" target="_blank" class="font-semibold"
            >music-making</a
          >, and
          <a
            href="https://perthirtysix.com"
            target="_blank"
            class="font-semibold"
            >data visualization</a
          >.
        </p>

        <p>
          The internet should be a more fun, communal, and quirky place than it
          has been, and I hope this experiment captures a bit of that!
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import P5Canvas from "./P5Canvas.vue";
import { ref, onMounted, onUnmounted, computed, watch } from "vue";

// import badwords array from badWords.js
import { badWords } from "./badWords";
const badWordsSet = new Set(badWords);

// import { Filter } from "bad-words";

const isMobile = navigator.userAgent.match(
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
);
const ADD_POST_INTERVAL = 25;

// Reference to the P5Canvas component
const p5Canvas = ref(null);

// WebSocket connection
const socket = ref(null);

// State for speed and skip logic
const speed = ref("slow"); // "fast" or "slow"
const fontSize = ref(isMobile ? "medium" : "small");
const skipLogic = ref("skip"); // "queue" or "skip"

const isHidden = ref(false);

const selectedFont = ref("Arial");

const emojiOnly = ref(false);
const emojisToHide = ["🍆", "🍑", "😈", "💦", "👅", "🥵", "🖕"];

const fonts = ref([
  { label: "Arial", value: "Arial" },
  // { label: "Avenir", value: "Avenir" },
  // { label: "Comic Sans MS", value: "Comic Sans MS" },
  { label: "Courier New", value: "Courier New" },
  { label: "Fredoka", value: "Fredoka" },
  { label: "Georgia", value: "Georgia" },
  { label: "Poppins", value: "Poppins" },
  { label: "Times New Roman", value: "Times New Roman" },
  // { label: "Verdana", value: "Verdana" },
]);

// State for play/pause
const paused = ref(false);
const togglePause = () => {
  paused.value = !paused.value;
};

const filterProfanity = ref(true);
// const badWordsFilter = new Filter(); // Initialize bad-words filter

// State for settings dialog visibility
const isSettingsVisible = ref(false);
const isInfoVisible = ref(false);

const toggleDialogVisible = () => {
  isSettingsVisible.value = !isSettingsVisible.value;
};

const toggleInfoVisible = () => {
  isInfoVisible.value = !isInfoVisible.value;
};

const ignoreHoverInCanvas = computed(() => {
  return isSettingsVisible.value || isInfoVisible.value;
});

const openCoffeePage = () => {
  window.open("https://www.buymeacoffee.com/shrikhalpada");
};

const filterInput = ref("");

// When we go to emoji mode, clear the filter input
watch(emojiOnly, (newValue) => {
  if (newValue) {
    filterInput.value = "";
  }
});

let lastPostAddedAt = 0;

// Handle incoming messages
const handleNewMessage = (event) => {
  if (isHidden.value) {
    return;
  }

  const now = Date.now();

  const shouldApplyLastPostInterval =
    (isMobile && speed.value === "slow") || (!isMobile && !emojiOnly.value);

  if (shouldApplyLastPostInterval && now - lastPostAddedAt < ADD_POST_INTERVAL)
    return;

  try {
    const data = JSON.parse(event.data);
    const postText = data.commit?.record?.text || "";

    if (data?.commit?.collection === "app.bsky.feed.post") {
      if (
        filterInput.value &&
        filterInput.value.length > 0 &&
        !postText.toLowerCase().includes(filterInput.value.toLowerCase())
      ) {
        return;
      }

      if (filterProfanity.value) {
        // Check for bad words or hidden emojis
        const containsProfanityOrEmojis =
          postText
            .split(/\b/) // Split by word boundaries to check words separately
            .some((word) => badWordsSet.has(word.toLowerCase())) ||
          Array.from(postText).some((char) => emojisToHide.includes(char));

        if (containsProfanityOrEmojis) {
          return; // Skip the post
        }
      }

      p5Canvas.value?.addEvent(data);
      lastPostAddedAt = now;
    }
  } catch (error) {
    console.error("Error processing message:", error);
  }
};

// Establish WebSocket connection
const connectWebSocket = () => {
  if (socket.value?.readyState === WebSocket.OPEN) {
    return;
  }

  socket.value = new WebSocket(
    "wss://jetstream2.us-east.bsky.network/subscribe?wantedCollections=app.bsky.feed.post"
  );

  socket.value.onopen = () => {
    console.log("WebSocket Connected");
  };

  socket.value.onmessage = handleNewMessage;

  socket.value.onerror = (error) => {
    console.error("WebSocket Error:", error);
  };

  socket.value.onclose = () => {
    console.log("WebSocket Disconnected");
    // Reconnect after a delay
    setTimeout(connectWebSocket, 5000);
  };
};

// Keyboard shortcuts
const handleKeydown = (event) => {
  // Check if the currently focused element is the filter input
  if (event.code === "Space" && document.activeElement.tagName !== "INPUT") {
    event.preventDefault(); // Prevent default spacebar scrolling
    togglePause();
  }
};

const handleVisibilityChange = () => {
  if (document.hidden) {
    isHidden.value = true;
  } else {
    isHidden.value = false;
  }
};

// Lifecycle hooks
onMounted(() => {
  connectWebSocket();
  document.addEventListener("keydown", handleKeydown);
  document.addEventListener("visibilitychange", handleVisibilityChange);
});

onUnmounted(() => {
  if (socket.value) {
    socket.value.close();
  }
  document.removeEventListener("keydown", handleKeydown);
  document.removeEventListener("visibilitychange", handleVisibilityChange);
});

const blurAll = () => {
  document.activeElement.blur();
};
</script>

<style>
.wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.glass-pill {
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.68);
  box-shadow: 0 12px 34px rgba(23, 69, 140, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px) saturate(140%);
}

.creator-pill {
  opacity: 0.92;
}

.dream-button {
  border-radius: 999px !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  background: rgba(255, 255, 255, 0.78) !important;
  box-shadow: 0 12px 30px rgba(23, 69, 140, 0.18) !important;
  backdrop-filter: blur(20px) saturate(140%);
}

.floating-icons svg {
  filter: drop-shadow(0 10px 18px rgba(23, 69, 140, 0.24));
  opacity: 0.9;
  transition: opacity 0.2s ease, transform 0.2s ease, filter 0.2s ease;
}

.floating-icons svg:hover,
.floating-icons svg:focus-visible {
  filter: drop-shadow(0 12px 24px rgba(255, 244, 187, 0.48));
  opacity: 1;
  transform: translateY(-3px) rotate(-2deg);
}

/* Style radio buttons to be more visible on dark background */
input[type="radio"] {
  accent-color: white;
  cursor: pointer;
}

/* Style for the play/pause button */
button {
  transition: background-color 0.2s ease;
}

.el-dialog {
  border: 1px solid rgba(255, 255, 255, 0.55) !important;
  border-radius: 24px !important;
  background: rgba(255, 255, 255, 0.86) !important;
  box-shadow: 0 24px 80px rgba(13, 44, 102, 0.28) !important;
  backdrop-filter: blur(18px) saturate(135%);
  margin-top: 4vh !important;
  opacity: 0.95 !important;
}

.el-overlay {
  backdrop-filter: blur(3px);
}

.el-input__wrapper,
.el-select__wrapper {
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.82) !important;
  box-shadow: 0 10px 28px rgba(23, 69, 140, 0.16) !important;
}

.el-radio-button__inner {
  border-color: rgba(64, 112, 190, 0.2) !important;
}

.el-radio-button__original-radio:checked + .el-radio-button__inner {
  background: rgba(78, 142, 255, 0.92) !important;
  border-color: transparent !important;
  box-shadow: 0 8px 20px rgba(78, 162, 255, 0.3) !important;
}
</style>
